/* eslint-disable react/no-danger */
import { Builder } from '@builder.io/react';
import classNames from 'classnames';

import { cleanBuilderStringInput } from '../../text';

interface BuilderInput {
  title: string;
  step1Title: string;
  step1SubTitle: string;
  step2Title: string;
  step2SubTitle: string;
  step3Title: string;
  step3SubTitle: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes?: any;
}

type Props = { locale: string } & BuilderInput;

export function HowItWorks({
  title = 'How it works',
  step1Title = 'Discover',
  step1SubTitle = 'Explore thousands of special objects selected by experts.',
  step2Title = 'Bid',
  step2SubTitle = 'Experience the thrill of an auction and place the top bid.',
  step3Title = 'Buy',
  step3SubTitle = 'Pay via our secure payment system and receive your special object.',
  attributes,
}: Props) {
  return (
    <div {...attributes}>
      <div className={classNames('u-wrapper', 'p-how-it-works', 'u-m-t-l')}>
        <div className="c-hiw u-m-t-xxl-10">
          <h2
            className="u-typography-h2"
            dangerouslySetInnerHTML={{ __html: cleanBuilderStringInput(title) }}
          />
        </div>
        <div className="c-hiw-items c-hiw u-m-t-xxl-2 tw:flex tw:justify-between">
          <div className="c-hiw-item u-p-s">
            <div className="hiw__circle tw:flex u-typography-h3">
              <span className="u-bgcolor-brand tw:flex tw:items-center">1</span>
            </div>
            <div className="hiw__text u-m-t-xxl-2">
              <div className="u-typography-h3 u-color-primary">
                {cleanBuilderStringInput(step1Title, true)}
              </div>
              <p className="u-typography-h8">
                {cleanBuilderStringInput(step1SubTitle, true)}
              </p>
            </div>
          </div>
          <div className="c-hiw-item u-p-s">
            <div className="hiw__circle tw:flex tw:items-center u-typography-h3">
              <span className="u-bgcolor-brand tw:flex tw:items-center">2</span>
            </div>
            <div className="hiw__text u-m-t-xxl-2">
              <div className="u-typography-h3 u-color-primary">
                {cleanBuilderStringInput(step2Title, true)}
              </div>
              <p className="u-typography-h8">
                {cleanBuilderStringInput(step2SubTitle, true)}
              </p>
            </div>
          </div>
          <div className="c-hiw-item u-p-s">
            <div className="hiw__circle tw:flex tw:items-center u-typography-h3">
              <span className="u-bgcolor-brand tw:flex tw:items-center">3</span>
            </div>
            <div className="hiw__text u-m-t-xxl-2">
              <div className="u-typography-h3 u-color-primary">
                {cleanBuilderStringInput(step3Title, true)}
              </div>
              <p className="u-typography-h8">
                {cleanBuilderStringInput(step3SubTitle, true)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function dataFetcher(locale: string) {
  return async () => ({
    locale,
  });
}

export function componentRegister() {
  const name = 'HowItWorks';
  Builder.registerComponent(HowItWorks, {
    name,
    inputs: [
      {
        name: 'title',
        type: 'string',
        defaultValue: 'How it works',
      },
      {
        name: 'step1Title',
        type: 'string',
        defaultValue: 'Discover',
        friendlyName: 'Step1 Title',
      },
      {
        name: 'step1SubTitle',
        type: 'string',
        defaultValue:
          'Explore thousands of special objects selected by experts.',
        friendlyName: 'Step1 Sub Title',
      },
      {
        name: 'step2Title',
        type: 'string',
        defaultValue: 'Bid',
        friendlyName: 'Step2 Title',
      },
      {
        name: 'step2SubTitle',
        type: 'string',
        defaultValue:
          'Experience the thrill of an auction and place the top bid.',
        friendlyName: 'Step2 Sub Title',
      },
      {
        name: 'step3Title',
        type: 'string',
        defaultValue: 'Buy',
        friendlyName: 'Step3 Title',
      },
      {
        name: 'step3SubTitle',
        type: 'string',
        defaultValue:
          'Pay via our secure payment system and receive your special object.',
        friendlyName: 'Step3 Sub Title',
      },
    ],
    hideFromInsertMenu: true,
    noWrap: true,
  });
  return name;
}
